<div class="departure-dashboard">
    <div class="departure-header">
        <p class="departure-title">Unidades por liberar</p>
        <p class="departure-subtitle">Unidades programadas que requieren check de salida.</p>
    </div>

    <div class="departure-kpi-grid">
        <div class="departure-kpi-card">
            <div class="departure-kpi-icon departure-kpi-icon--amber"><img src="assets/img/departure-check/icon-kpi-clock.svg" alt=""></div>
            <div class="departure-kpi-text">
                <p class="departure-kpi-value">{{stats.pendientes}}</p>
                <p class="departure-kpi-label">Pendientes</p>
                <p class="departure-kpi-sublabel">Por iniciar check</p>
            </div>
        </div>
        <div class="departure-kpi-card">
            <div class="departure-kpi-icon departure-kpi-icon--teal"><img src="assets/img/departure-check/icon-kpi-check.svg" alt=""></div>
            <div class="departure-kpi-text">
                <p class="departure-kpi-value">{{stats.ruta_a_carga}}</p>
                <p class="departure-kpi-label">Ruta a carga</p>
                <p class="departure-kpi-sublabel">Iniciaron servicio</p>
            </div>
        </div>
        <div class="departure-kpi-card">
            <div class="departure-kpi-icon departure-kpi-icon--purple"><img src="assets/img/departure-check/icon-kpi-calendar.svg" alt=""></div>
            <div class="departure-kpi-text">
                <p class="departure-kpi-value">{{stats.total}}</p>
                <p class="departure-kpi-label">Total de servicios</p>
                <p class="departure-kpi-sublabel">Programados hoy</p>
            </div>
        </div>
    </div>

    <div class="departure-table-card">
        <!-- Ancho completo (>=1000px, Figma 1134): filtros siempre visibles en fila -->
        <div class="departure-filters departure-filters--wide">
            <div class="departure-filter-group">
                <label>Folio</label>
                <input type="text" placeholder="#1234" [(ngModel)]="filterFolio" (ngModelChange)="onFilterChanged()">
            </div>
            <div class="departure-filter-group">
                <label>Unidad</label>
                <select [(ngModel)]="filterUnitId" (ngModelChange)="onFilterChanged()">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let u of units" [value]="u.id">{{u.unit}}</option>
                </select>
            </div>
            <div class="departure-filter-group">
                <label>Operador</label>
                <select [(ngModel)]="filterDriverId" (ngModelChange)="onFilterChanged()">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let d of drivers" [value]="d.id">{{d.name}} {{d.last_name}}</option>
                </select>
            </div>
            <div class="departure-filter-group">
                <label>Salida programada</label>
                <input type="date" [(ngModel)]="filterDepartureDate" (ngModelChange)="onFilterChanged()">
            </div>
        </div>

        <!-- Tablet angosta (<1000px, Figma 742): boton que abre el panel inferior de filtros -->
        <div class="departure-filters-narrow">
            <button type="button" class="departure-filter-toggle-btn" (click)="openFilterDrawer()">
                <img src="assets/img/departure-check/icon-filter-funnel.svg" alt=""> Filtrar servicios
            </button>
        </div>

        <div class="departure-empty" *ngIf="!loading && rows.length === 0">
            No hay unidades pendientes de check de salida con los filtros actuales.
        </div>

        <div class="departure-table-scroll" *ngIf="rows.length > 0">
            <div class="departure-table-header-row">
                <span class="col-service">Servicio / Unidad</span>
                <span class="col-operator">Operador</span>
                <span class="col-departure">Salida programada</span>
                <span class="col-status">Estado</span>
                <span class="col-actions">Acciones</span>
            </div>

            <div class="departure-table-row" *ngFor="let row of rows">
                <div class="col-service">
                    <p class="row-folio">#{{row.folio}}</p>
                    <p class="row-unit">{{row.unit}}<span *ngIf="row.unit_configuration"> ({{row.unit_configuration}})</span></p>
                    <p class="row-plates">{{row.plates}}</p>
                </div>
                <div class="col-operator">
                    <p class="row-driver-name">{{row.driver_name | titlecase}}</p>
                    <p class="row-driver-phone">{{row.driver_phone}}</p>
                </div>
                <div class="col-departure">
                    <img src="assets/img/departure-check/icon-row-calendar.svg" alt="">
                    <div>
                        <p class="row-departure-time">{{formatDateTime(row.departure_date, row.departure_time).time}}</p>
                        <p class="row-departure-date">{{formatDateTime(row.departure_date, row.departure_time).date}}</p>
                    </div>
                </div>
                <div class="col-status">
                    <span class="departure-status-pill" [ngClass]="rowStateClass(row)">
                        <img [src]="rowStateIcon(row)" alt="">
                        {{rowStateLabel(row)}}
                    </span>
                </div>
                <div class="col-actions">
                    <button *ngIf="row.departure_check_status !== 'update_requested'" type="button" class="departure-action-btn" [class.departure-action-btn--link]="row.departure_check_status === 'completed'" (click)="onRowAction(row)">
                        {{rowActionLabel(row)}} <img [src]="row.departure_check_status === 'completed' ? 'assets/img/departure-check/icon-row-chevron-right-blue.svg' : 'assets/img/departure-check/icon-row-chevron-right.svg'" alt="">
                    </button>
                    <button *ngIf="row.departure_check_status === 'update_requested'" type="button" class="departure-action-btn departure-action-btn--link" (click)="onRowAction(row)">
                        Ver detalles
                    </button>
                </div>
            </div>
        </div>

        <div class="departure-pagination-bar" *ngIf="rows.length > 0">
            <span class="departure-pagination-label">{{paginationRangeLabel}}</span>
            <div class="departure-pagination" *ngIf="lastPage > 1">
                <button type="button" class="departure-pagination-arrow" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)"><img src="assets/img/departure-check/icon-pagination-prev.svg" alt=""></button>
                <button type="button" class="departure-pagination-page" *ngFor="let p of pageNumbers" [class.active]="p === currentPage" (click)="goToPage(p)">{{p}}</button>
                <button type="button" class="departure-pagination-arrow" [disabled]="currentPage === lastPage" (click)="goToPage(currentPage + 1)"><img src="assets/img/departure-check/icon-pagination-next.svg" alt=""></button>
            </div>
        </div>
    </div>

    <div class="departure-bottom-banner">
        <div class="departure-banner-icon"><img src="assets/img/departure-check/icon-banner-info.svg" alt=""></div>
        <div>
            <p class="departure-banner-title">Recuerda realizar el check de salida</p>
            <p class="departure-banner-text">Verifica el estado de la unidad, documentación y registra las evidencias antes de liberar la unidad para el servicio.</p>
        </div>
    </div>
</div>

<!-- Panel inferior de filtros (tablet angosta) -->
<div class="departure-filter-drawer-backdrop" *ngIf="showFilterDrawer" (click)="closeFilterDrawer()"></div>
<div class="departure-filter-drawer" *ngIf="showFilterDrawer">
    <div class="departure-filter-drawer-header">
        <p>Filtrar servicios</p>
        <button type="button" (click)="closeFilterDrawer()"><img src="assets/img/departure-check/icon-close-x.svg" alt="Cerrar"></button>
    </div>
    <div class="departure-filter-drawer-body">
        <div class="departure-filter-drawer-row">
            <div class="departure-filter-group">
                <label>Salida programada</label>
                <input type="date" [(ngModel)]="draftDepartureDate">
            </div>
            <div class="departure-filter-group">
                <label>Unidad</label>
                <select [(ngModel)]="draftUnitId">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let u of units" [value]="u.id">{{u.unit}}</option>
                </select>
            </div>
        </div>
        <div class="departure-filter-drawer-row">
            <div class="departure-filter-group">
                <label>Operador</label>
                <select [(ngModel)]="draftDriverId">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let d of drivers" [value]="d.id">{{d.name}} {{d.last_name}}</option>
                </select>
            </div>
            <div class="departure-filter-group">
                <label>Folio</label>
                <input type="text" placeholder="#1234" [(ngModel)]="draftFolio">
            </div>
        </div>
    </div>
    <div class="departure-filter-drawer-footer">
        <button type="button" class="departure-btn-outline" (click)="closeFilterDrawer()">Cancelar</button>
        <button type="button" class="departure-btn-primary" (click)="applyFilterDrawer()">Aplicar filtros</button>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
